import { Form, FormInstance, Input, Typography } from 'antd';
import '../scss/Login.scss';
import { CHANGE_PASSWORD } from '../../../utils/constants/itemScreen';
import { InputProps } from '../../../interfaces/common';
interface ChangePasswordProps {
  form: FormInstance;
  fieldsChangePassword: InputProps[];
  onFinish: (values: ChangePasswordRequest) => void;
  onFinishFailed: () => void;
}

const ChangePassword = (props: ChangePasswordProps) => {
  const { form, fieldsChangePassword, onFinish, onFinishFailed } = props;

  return (
    <>
      <Typography>{CHANGE_PASSWORD.TITLE}</Typography>
      <Form
        form={form}
        name="changePasswordForm"
        layout="vertical"
        className="change-password-form"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        {fieldsChangePassword.map(field => (
          <Form.Item
            key={field.name}
            label={field.label}
            name={field.name}
            dependencies={field.dependencies}
            rules={field.validate}
            required
          >
            <Input.Password maxLength={field.maxLength} />
          </Form.Item>
        ))}
      </Form>
    </>
  );
};

export default ChangePassword;
